document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Swatch Collapse Fix Loaded");

    function enableSwatchButton() {
        console.log("✅ Enabling '+ More' Button...");

        document.querySelectorAll(".gsw-list-products-group").forEach(wrapper => {
            let swatches = Array.from(wrapper.querySelectorAll(".gsw-prg-item")); // Convert to array

            // Remove existing "+ More" button to prevent duplication
            wrapper.querySelectorAll(".gsw-more-button").forEach(btn => btn.remove());

            if (swatches.length > 4) {
                let moreButton = document.createElement("button");
                moreButton.innerHTML = "+";
                moreButton.classList.add("gsw-more-button");

                // Insert button **before** the first swatch
                wrapper.insertBefore(moreButton, swatches[0]);

                // **Ensure only the first 4 swatches are visible initially**
                swatches.forEach((swatch, index) => {
                    if (index >= 4) {
                        swatch.style.display = "none"; // Hide extra swatches
                    } else {
                        swatch.style.display = "inline-block"; // Show first 4 swatches
                    }
                });

                // **Expand/collapse swatches on button click**
                moreButton.addEventListener("click", function (event) {
                    event.preventDefault();
                    event.stopPropagation(); // Prevent conflicts with other scripts

                    let isExpanded = wrapper.classList.toggle("expanded");

                    if (isExpanded) {
                        console.log("➡️ Expanding swatches...");
                        swatches.forEach(swatch => swatch.style.display = "inline-block");
                        moreButton.innerHTML = "-";
                    } else {
                        console.log("↩️ Collapsing swatches...");
                        swatches.forEach((swatch, index) => {
                            if (index >= 4) swatch.style.display = "none";
                        });
                        moreButton.innerHTML = "+";
                    }
                });
            }
        });
    }

    function initializeSwatchFix() {
        enableSwatchButton();
    }

    function waitForSwatchFix() {
        let checkExist = setInterval(() => {
            let swatchGroups = document.querySelectorAll(".gsw-list-products-group");

            if (swatchGroups.length > 0) {
                console.log("✅ Swatches detected! Running initializeSwatchFix...");
                clearInterval(checkExist);
                initializeSwatchFix();
            }
        }, 500);
    }

    // 🚀 Fix for Shopify Section Reloads
    document.addEventListener("shopify:section:load", function () {
        console.log("🔄 Shopify Section Reload Detected - Reinitializing Swatch Fix");
        setTimeout(initializeSwatchFix, 500);
    });

    waitForSwatchFix();
});